module.exports = __webpack_public_path__ + "img/rang5.8903dc31.png";